import React from "react";
import resumeFile from "../documents/resume.pdf";

const Resume = () => {
  const skillGroups = [
    {
      title: "توسعه محصول",
      items: "TypeScript، JavaScript، Python، Node.js، React، Next.js، Swift، Flutter",
    },
    {
      title: "Backend و داده",
      items: "REST API، GraphQL، PostgreSQL، MongoDB، Redis، Socket.IO، MQTT",
    },
    {
      title: "تحویل و نگهداری",
      items: "Docker، Docker Compose، CI/CD، Git، تست، مستندسازی و استقرار",
    },
    {
      title: "نقش در پروژه",
      items: "تحلیل نیازمندی، طراحی معماری، توسعه، Code Review، مدیریت فنی و رفع مشکل",
    },
  ];

  return (
    <section id="resume" className="section">
      <div className="container">
        <p className=" text-center mb-2 wow fadeInUp">
          <span className="bg-primary text-dark px-2">رزومه</span>
        </p>
        <h2 className="text-10 fw-600 text-center mb-3 wow fadeInUp">توانمندی‌هایی برای تحویل بهتر</h2>
        <p className="text-muted text-center text-5 mb-5 wow fadeInUp">
          ابزارها بر اساس نیاز پروژه انتخاب می‌شوند؛ معیار اصلی، راه‌حل قابل‌اعتماد و قابل‌نگهداری است.
        </p>

        <div className="row gy-4">
          {skillGroups.map((group) => (
            <div className="col-md-6 wow fadeInUp" key={group.title}>
              <div className="border rounded p-4 h-100">
                <h3 className="text-5 fw-600 mb-3">{group.title}</h3>
                <p className="text-muted mb-0">{group.items}</p>
              </div>
            </div>
          ))}
        </div>

        <p className="text-muted text-center">
          برای مشاهده‌ی سابقه‌ی کامل Academic و Professional، رزومه را دریافت کنید.
        </p>
        <p className="text-center mt-5 wow fadeInUp">
          <a className="btn btn-dark rounded-5 smooth-scroll mt-3" href={resumeFile} download>
            دانلود رزومه
          </a>
        </p>
      </div>
    </section>
  );
};

export default Resume;
